(function ($) {
  if((window.location.host.split('.')[2] == 'sk') || (window.location.host.split('.')[2] == 'cz')) {
    var win = $(window),
      widget = $('.mail-director');
    $('.mail-director-toggle').click(toggleMailDirector);
    $('.mail-director-close').click(toggleMailDirector);

    function toggleMailDirector(e) {
      e.preventDefault();

      window.generalFormPostRenderFunction = function () {
        $('body').find('.director-form input, .director-form textarea').each(function () {
          if ($(this).val() !== '') {
            $(this).siblings('label').hide();
          }
        });
      }
      window.generalFormPostRenderFunction = function () {
        if (window.innerWidth <= 1145)
          $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
      }


      if (widget.hasClass('expanded'))
        widget.removeClass('expanded');
      else
        widget.addClass('expanded');

      $('.director-form').empty();
      $('.director-form').generalForm({
        'dataPath': '/sys/bloky/form/napiste-rediteli.jsp?form=1',
        'noFormClass': true,
        'noScroll': true
      });

      // fix pro captchu - script pro zobrazeni captchi se na Firefox a IE nenacita, toto jej vola rucne po otevreni formulare.
      //Timeout nastaveny diky opozdenemu nacteni objektu grecaptchaOnloadCallback, bez tohoto se captcha neinicializuje
      setTimeout(function () {
        if ($('.mail-director').hasClass('expanded')) {
          try {
            window.grecaptchaOnloadCallback();
          } catch (err) {
            console.log('Firefox, IE captcha loader fix.')
          };
        };
      }, 500);
    }

    $('body').on('keydown', '.director-form input, .director-form textarea', function () {
      $(this).siblings('label').hide();
    });
    $('body').on('keyup', '.director-form input, .director-form textarea', function () {
      if ($(this).val() === '')
        $(this).siblings('label').show();
    });
    $('body').on('blur', '.director-form input, .director-form textarea', function () {
      if ($(this).val() === '')
        $(this).siblings('label').fadeTo(100, 1);
    });
    $('body').on('focus', '.director-form input, .director-form textarea', function () {
      if ($(this).val() === '')
        $(this).siblings('label').fadeTo(100, 0.3);
    });

    // media query change
    function WidthChange(mq) {

      if (mq.matches) {
        var widget = $('.mail-director');

        if (widget.hasClass('expanded')) {
          var directorForm = $('.mail-director-form').height();

          $('html, body').animate({ scrollTop: $(document).height() - directorForm }, 500);
        }
      }
    }

    var initOffset,
      offsetAll,
      curOffset,
      headerHeight,
      status = true,
      offset = 100, // odsazeni od hlavicky
      dir = $('.mail-director'),
      headerMenu = $('.header-menu'),
      headerPerma = $('.header-permanent');

    // zpozdime script, jinak se stava, ze se ruzne pocita odsazeni reditele
    var timer = setTimeout(function () {
      initOffset = dirInit();
      win.scroll(checkDir);
    }, 600)

    function checkDir() {
      offsetAll = countHeaderHeight();

      // provede se pouze pokud nemame odskrolovano
      if (status) {
        curOffset = dir.offset().top;
        status = false;
      }
      // pokud je fixni
      if (win.scrollTop() + offsetAll > curOffset) {
        dir.addClass('director-fixed').css({
          'top': offsetAll + 'px'
        });
      }
      // pokud neni fixni
      else {
        dir.removeClass('director-fixed').css({
          'top': initOffset + 'px'
        });
      }
    }

    function dirInit() {
      var cm = $('#content-middle'),
        offsetCm = cm.offset().top,
        widgetOffsetTopCorrection = 200; // odsazeni px od #content-middle

      widget.css({ top: offsetCm + widgetOffsetTopCorrection + 'px' });

      if (win.scrollTop() > 0) {
        status = false;
        curOffset = dir.offset().top;

        offsetAll = countHeaderHeight();

        if (win.scrollTop() + offsetAll > curOffset) {
          dir.addClass('director-fixed').css({
            'top': offsetAll + 'px'
          });
        }
      }

      return offsetCm + widgetOffsetTopCorrection;
    }

    function countHeaderHeight() {
      headerHeight = headerPerma.outerHeight() + headerMenu.outerHeight();
      return offsetAll = headerHeight + offset;
    }
  }

})(jQuery);
